@if (!pages || pages.length === 0) {
<p class="mat-body-1">
  {{ "ONSIP_I18N.APPEARS_ON_ALL_PAGES" | translate }}
</p>
} @if (rules && rules.length) {
<p class="mat-body-1">{{ "ONSIP_I18N.RULES" | translate }}</p>
@for (rule of rules; track rule) {
<p>
  <span class="page-rule-line">{{ translatedVerbs[rule[0]] | titlecase }}:</span>
  <span class="mat-body-1">{{ rule[1] }}</span>
  <br />
</p>
} } @if (exceptions && exceptions.length) {
<p class="mat-body-1">{{ "ONSIP_I18N.EXCEPTIONS" | translate }}</p>
@for (exception of exceptions; track exception) {
<p>
  <span class="page-rule-line">{{ translatedVerbs[exception[0]] | titlecase }}:</span>
  <span class="mat-body-1">{{ exception[1] }}</span>
  <br />
</p>
} }
